export const TEMPORAL = 'PPTCVENTLIST0001'

export const __dictionary = {
  [TEMPORAL]: {
    id: TEMPORAL,
    nombre: 'TEMPORAL'
  }
}

export const __array = [TEMPORAL]
